import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import {
  headerHeightSelector,
  isHeaderHiddenSelector
} from '../../selectors/header';

const StickyWrapper = styled.div<{
  $offsetTop: number;
  $offsetBottom: number;
}>`
  position: sticky;
  top: ${({ $offsetTop }) => $offsetTop}px;
  max-height: ${({ $offsetBottom }) => `calc(100vh - ${$offsetBottom}px)`};
  overflow-y: auto;
`;

interface Props {
  min?: number;
  max?: number;
  topOffset?: number;
  bottomOffset?: number;
  children: ReactNode;
}

const StickyBlock = ({
  min,
  max,
  topOffset = 0,
  bottomOffset = 0,
  children
}: Props) => {
  const [isSticky, setSticky] = useState<boolean>(true);

  const headerHeight = useSelector(headerHeightSelector);
  const hideHeader = useSelector(isHeaderHiddenSelector);

  const calculateSticky = useCallback(() => {
    const wWidth = window.innerWidth;
    const goMin = !min || wWidth >= min;
    const goMax = !max || wWidth <= max;

    setSticky(goMin && goMax);
  }, [min, max]);

  useEffect(() => {
    calculateSticky();
    window.addEventListener('resize', calculateSticky, false);

    return () => {
      window.removeEventListener('resize', calculateSticky, false);
    };
  }, [calculateSticky]);

  const offsetTop = hideHeader ? 0 : Number(headerHeight) + Number(topOffset);
  const offsetBottom = Number(headerHeight) + Number(bottomOffset);

  if (isSticky) {
    return (
      <StickyWrapper $offsetTop={offsetTop} $offsetBottom={offsetBottom}>
        {children}
      </StickyWrapper>
    );
  }

  return <>{children}</>;
};

export default StickyBlock;
